export default __webpack_public_path__ + "locales/uk-UA/Translations.json?hash=22b678f4a18c41336e1f7f3979bbe09a";